<template>
	<div class="date-picker">
		<div class="picker">
			<i class="el-icon-arrow-left" v-bind:class="['previous', { active: previousActive }]" @click.native="previous"></i>
			<span class="date-range">
				{{ formatDate(startDate) }} to {{ formatDate(date) }}
			</span>
			<i class="el-icon-arrow-right" v-bind:class="['next', { active: nextActive }]" @click.native="next"></i>
		</div>
	</div>
</template>

<script>
// import Icon from '@/component/Icon'

import formatDate from '../util/format-date'

export default {
	props: {
		/**
		 * @prop 	startDate
		 * @type 	Date
		 * @desc	Starting date of the date picker
		 * @required
		 */
		startDate: {
			type: Date
		},

		/**
		 * @prop 	date
		 * @type 	Date
		 * @desc	Ending date of the date picker
		 * @required
		 */
		date: {
			type: Date
		}
	},

	computed: {
		/**
		 * @function 	nextActive
		 * @desc		If there are any entries next to current date range
		 */
		nextActive() {
			return this.date.getTime() < Date.now()
		},
		/**
		 * @function 	previousActive
		 * @desc		If there are any entries previous to current date range
		 */
		previousActive() {
			// TODO: if there are no readings before the current date
			return true
		}
	},

	methods: {
		formatDate,

		/**
		 * @function 	previous
		 * @desc		Emit the parent compoennt's method 'previous' to change the date range to previous date range
		 */
		previous() {
			this.$emit('previous')
		},
		/**
		 * @function 	next
		 * @desc		Emit the parent compoennt's method 'next' to change the date range to next date range
		 */
		next() {
			this.$emit('next')
		}
	},

	components: {
	}
}
</script>

<style scoped lang="scss">
.date-picker {
	display: block;
    text-align: center;
    padding: 25px 10px;
	height: 60px;
	line-height: 10px;

	.picker {
		display: inline-block;
		width: 250px;
		> * {
	        float: left;
	    }

	    .date-range {
			min-width: 150px;
			margin-top: 0px;
	    }

	    .previous, .next {
			opacity: 0.8;
			transition: opacity 0.2s ease-in-out;
	        padding: 0px 10px;
			margin-top: -10px;
	    }
		.previous.active:hover, .next.active:hover {
			opacity: 1.0;
			cursor: pointer;
		}
		.previous:not(.active),
		.next:not(.active) {
			opacity: 0.2;
		}
	}
}
</style>
